import React from "react";
import { t } from "ttag";

import { Image } from "../../../common/Image";
import { Link } from "../../../common/Link";
import { IProduct } from "../../../models/catalogue";
import { navigateToURL } from "../../../utils/urls";

import styles from "./common.module.scss";

export const BasketLineImage = (props: {
    product: IProduct;
}): React.ReactNode => {
    // Use the product image if one exists else try the parent image
    let image = props.product.images.slice().shift();
    if (!image && props.product.parent) {
        image = props.product.parent.images.slice().shift();
    }
    if (!image) {
        return null;
    }
    const onGoToProduct = () => {
        if (!props.product.link) {
            return;
        }
        navigateToURL(props.product.link);
    };

    // Refs #22223 - Prevents rendering multiple link wrappers to the same location
    // to avoid ADA issues. If parent link exists, renders image link wrapper.
    if (props.product.parent?.link) {
        return (
            <Link
                className={styles.link}
                href={props.product.parent.link}
                target="_top"
            >
                <Image
                    className={styles.image}
                    alt={t`Learn more about ${props.product.title}`}
                    src={image.original}
                />
            </Link>
        );
    }

    return (
        <div className={styles.link} onClick={onGoToProduct}>
            <Image className={styles.image} alt="" src={image.original} />
        </div>
    );
};
